import type { UseMutationResponse } from '@urql/vue';
import { GraphqlCommandBuilder } from './graphql-command-builder';
import { RestCommandBuilder } from './rest-command-builder';

// Keeping this for backwards compatibility
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class InfrastructureCommandBuilder {
  static fromMutation<T, V extends Record<string, unknown>>(
    mutation: UseMutationResponse<T, V>,
    args: V,
  ): GraphqlCommandBuilder<T, V, void> {
    return GraphqlCommandBuilder.fromMutation(mutation, args);
  }

  static fromFetch<T, A extends Record<string, unknown>>(
    fetchFn: () => Promise<T>,
  ): RestCommandBuilder<T, A, void> {
    return RestCommandBuilder.fromFetch(fetchFn);
  }
}
